module.exports = __webpack_public_path__ + "img/m-banner-kfkmkuef-th-TH.ac2f9e51.png";